<script>
export default {
  name: 'payment-bookings',
  computed: {
    bookings() {
      return this.$store.getters['payment/billingData'].bookings
    },
  }
}
</script>
<template>
  <div class="payment-bookings">
    <div
      v-for="(service, index) in bookings"
      :key="index"
      class="payment-bookings__item"
    >
      <p class="payment-bookings__item-header">
        {{ service.name }}
      </p>
      <p class="order-payment__services-item-details">
        {{ service.value }}
      </p>
    </div>
  </div>
</template>